"use strict";

exports.__esModule = true;
exports.default = exports.UnwrappedTooltip = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tborder-bottom: ", "px dotted\n\t\t", ";\n\tcolor: ", ";\n\t&:hover {\n\t\tcursor: help;\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t&:hover + ", " {\n\t\tpointer-events: all;\n\t\topacity: 0.9;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmax-width: 100%;\n\tposition: absolute;\n\tmargin-top: ", ";\n\topacity: ", ";\n\tpointer-events: none;\n\ttransition: opacity ease 0.25s;\n\tz-index: 9999;\n\tbackground-color: ", ";\n\tcolor: #fff;\n\tpadding: ", ";\n\tborder-radius: ", ";\n\tz-index: 1;\n\tfont-size: 14px;\n\tmargin-right: ", ";\n\n\t&:after {\n\t\tcontent: '';\n\t\twidth: fit-content;\n\t\twhite-space: nowrap;\n\t\theight: 0;\n\t\tposition: absolute;\n\t\ttop: -", ";\n\t\tleft: ", ";\n\t\tborder-left: ", " solid transparent;\n\t\tborder-right: ", " solid transparent;\n\t\tborder-bottom: ", " solid ", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Container = _styledComponents.default.div(_templateObject(), _spacing.default.s2, function (props) {
  return props.visibleOnClick ? 0.9 : 0;
}, _colors.default.greyDark, _spacing.default.s1, _vars.default.borderRadius, _spacing.default.s1, _spacing.default.s1, _spacing.default.s1, _spacing.default.s1, _spacing.default.s1, _spacing.default.s1, _colors.default.greyDark);

Container.displayName = 'Container';

var Label = _styledComponents.default.span(_templateObject2(), Container);

Label.displayName = 'Label';

var InnerToolTip = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.underline ? '2' : '0';
}, _colors.default.primary, _colors.default.primary);

InnerToolTip.displayName = 'InnerToolTip';

var UnwrappedTooltip =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(UnwrappedTooltip, _React$Component);

  function UnwrappedTooltip(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      visibleOnClick: false
    };
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = UnwrappedTooltip.prototype;

  _proto.handleClickOutside = function handleClickOutside() {
    this.setState({
      visibleOnClick: false
    });
  };

  _proto.toggleTooltip = function toggleTooltip() {
    this.setState(function (_ref) {
      var visibleOnClick = _ref.visibleOnClick;
      return {
        visibleOnClick: !visibleOnClick
      };
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        children = _this$props.children,
        gaAction = _this$props.gaAction,
        icon = _this$props.icon,
        rest = _objectWithoutPropertiesLoose(_this$props, ["label", "children", "gaAction", "icon"]);

    var visibleOnClick = this.state.visibleOnClick;
    return _react.default.createElement(InnerToolTip, _extends({
      underline: !!label
    }, rest), _react.default.createElement(Label, _extends({
      onClick: this.toggleTooltip,
      "data-track-tooltip": "true",
      "data-track-action": gaAction
    }, this.props), label || icon), _react.default.createElement(Container, {
      visibleOnClick: visibleOnClick
    }, children));
  };

  return UnwrappedTooltip;
}(_react.default.Component);

exports.UnwrappedTooltip = UnwrappedTooltip;
UnwrappedTooltip.displayName = 'Tooltip';
UnwrappedTooltip.propTypes = {
  label: _propTypes.string,
  children: _propTypes.node.isRequired,
  gaAction: _propTypes.string,
  icon: _propTypes.node
};
UnwrappedTooltip.defaultProps = {
  gaAction: '',
  label: undefined,
  icon: undefined
};

var _default = (0, _reactOnclickoutside.default)(UnwrappedTooltip, {
  excludeScrollbar: true
});

exports.default = _default;